<button class="tw-text-xl tw-p-2" (click)="toggleShortlist()">
  <fa-icon class="tw-text-pinkDark" *ngIf="isShortlisted" [icon]="faHeart"></fa-icon>
  <fa-icon class="tw-text-pinkDark" *ngIf="!isShortlisted" [icon]="faHeartRegular"></fa-icon>
</button>